import axios from 'axios';

const TrainingPathService = {
  async getTrainingPaths({ page = 1, limit = 20, search = '', acl = 'admin' }) {
    const response = await axios.get('/training-paths', {
      params: {
        page,
        limit,
        search,
        acl,
      },
    });

    return response.data;
  },

  async createTrainingPath({ name, description, resources, status }) {
    const response = await axios.post('/training-paths', {
      name,
      description,
      resources,
      status,
    });

    return response.data;
  },

  async updateTrainingPath({
    trainingPathId,
    name,
    description,
    resources,
    status,
  }) {
    const response = await axios.put(`/training-paths/${trainingPathId}`, {
      name,
      description,
      resources,
      status,
    });

    return response.data;
  },

  async getTrainingPath(trainingPathId, acl = 'admin') {
    const response = await axios.get(`/training-paths/${trainingPathId}`, {
      params: {
        acl,
      },
    });

    return response.data;
  },

  async assignUsers(trainingPathId, userIds) {
    const response = await axios.post(`/training-paths/${trainingPathId}/assign`, {
      userIds,
    });

    return response.data;
  },

  async updateAssignmentStatus({ assignmentId, status, statusMeta }) {
    const response = await axios.patch(`/training-paths/assignments/${assignmentId}`, {
      status,
      statusMeta,
    });

    return response.data;
  },

  async resetAssignmentProgress(assignmentId) {
    const response = await axios.post(
      `/training-paths/assignments/${assignmentId}/reset`
    );

    return response.data;
  },

  async recordSectionProgress({ assignmentId, sectionId, meetingId, progress }) {
    const response = await axios.post(
      `/training-paths/assignments/${assignmentId}/sections/${sectionId}`,
      {
        meetingId,
        progress,
      }
    );

    return response.data;
  },

  async getAssignment(assignmentId) {
    const response = await axios.get(`/training-paths/assignments/${assignmentId}`);
    return response.data;
  },

  async getSectionProgress(assignmentId, meetingId) {
    const response = await axios.get(
      `/training-paths/assignments/${assignmentId}/progress/${meetingId}`
    );
    return response.data;
  },

  async deleteTrainingPath(trainingPathId) {
    await axios.delete(`/training-paths/${trainingPathId}`);
  },
};

export default TrainingPathService;

